var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mt-3",attrs:{"color":_vm.extras.type === 'whatsapp' ? 'success' : 'primary',"outline":""},on:{"click":_vm.logInWithFacebook}},[_c('v-icon',[_vm._v(_vm._s(_vm.extras.type === "whatsapp" ? "mdi-whatsapp" : "mdi-facebook"))]),_vm._v("\n  "+_vm._s(_vm.extras.buttonText || "Continue With Facebook"))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }